export default "__VITE_ASSET__c2593e37__"